export default __webpack_public_path__ + "static/media/powertrain.c9030ccd.svg";